<template>
    <div :class="theme ? theme : ''">
        <ul class="superNavUl menu clearfix">
            <li class="b pr allCommdity navItem" >
                全部分类
                <Nav  class="nav"/>
            </li>
            <!--<Menu :selsectedKeys="[]" class="mainMenu" mode="horizontal">
                <template v-for="(item, i) in list">
                    <MenuSubMenu v-if="item.child && item.child.length" :key="i">
                        <span slot="title" >{{item.name}}</span>
                        <MenuItem v-for="(itemSub, j) in item.child" :key="j" @click="toCategory2(itemSub, itemSub.level)">{{itemSub.name}}</MenuItem>
                    </MenuSubMenu>
                    <MenuItem v-else :key="i" @click="toCategory2(item, item.level)">{{item.name}} </MenuItem>
                </template>
            </Menu>-->
        </ul>
    </div>
</template>

<script>
import Nav from '@/components/SuperNav/nav.vue'
//import { Menu } from 'ant-design-vue';
import 'ant-design-vue/lib/menu/style/index.css';
export default {
    name: 'SuperNav',
    props:['theme', 'list'],
    components: {
        Nav,
        /*Menu,
        MenuSubMenu: Menu.SubMenu,
        MenuItem: Menu.Item*/
    },
    data() {
        return {
            current: 0,
        }
    },
    methods: {
        toCategory1() {
            // drugCategory
        },
        toCategory2(data, level) {
            if(data.data_type === 'custom') {
                window.open(data.url)
            }else if(data.data_type ==='customview'){
                this.$router.push(`/custom/${data.value}`)
            }else if (data.data_type === 'article_class') {
                this.$router.push(`/explain/detail/${data.value}`)
            } else if(data.data_type === 'goods_category') {
                this.$router.push(`/drugCategory?${level === 1 ? 'category_id' : 'cat_id'}=${data.value}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .blue{
        .superNavUl{
            .navItem{
                color: #fff;
            }
            .navItem.b{
            }
        }
    }
    .superNavUl {
        .navItem{
            float: left;
            font-size: 16px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            padding: 0 33px;
        }
        .navItem.b{
            width: 200px;
            padding: 0;
            background: #1177b6;
            color: #fff;
            text-align: center;
        }
        .navItem .s {
            cursor: pointer;
        }
    }
    .home .allCommdity .nav{
        display: block;
    }
    .allCommdity .nav{
        display: none
    }
    .allCommdity:hover .nav{
        display: block;
    }
    .menu {
        display: flex;
    }
    .icon {
        list-style: none;
    }
    .mainMenu {
        font-size: 14px;
        line-height: 40px;
        font-weight: 700;
    }
</style>